import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import BasicBlankSlate from '../../_partials/BasicBlankSlate';

const AppsBlankSlate: FC = () => {
  const { t } = useTranslation();
  return (
    <BasicBlankSlate
      title={t('studio.blankSlate.apps.title')}
      message={t('studio.blankSlate.apps.subtitle')}
      ctaLabel={t('studio.blankSlate.apps.cta')}
      ctaHref={Url.to(URLS.REGISTER_APPLICATION)}
    />
  );
};
AppsBlankSlate.displayName = 'AppsBlankSlate';

export default AppsBlankSlate;
